import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncreaseArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_33357_700)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M7 11.8125V2.1875",
			stroke: "#3A8027",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.0625 6.125L7 2.1875L10.9375 6.125",
			stroke: "#3A8027",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_33357_700",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgIncreaseArrow;
